export default __webpack_public_path__ + "static/media/CCCR-registration.159dee44.svg";